import { giphyBlue, giphyGreen, giphyPink, giphyRed } from '@giphy/js-brand'
import React from 'react'

type Props = {
    className?: string
}

export const CheckIcon = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" className={className}>
        <defs>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="uploadcheckicongradient">
                <stop stopColor={giphyGreen} offset="0%" />
                <stop stopColor={giphyBlue} offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm3.496 4a.171.171 0 00-.134.06L7.376 8.546 5.638 6.584a.171.171 0 00-.134-.059.171.171 0 00-.134.06L4.057 8.058A.208.208 0 004 8.21c0 .061.019.112.057.151l3.183 3.58c.05.04.095.06.136.06.041 0 .086-.02.136-.06l5.43-6.105a.208.208 0 00.058-.15.208.208 0 00-.057-.151L11.63 4.059A.171.171 0 0011.496 4z"
            transform="translate(.771)"
            fill="url(#uploadcheckicongradient)"
            fillRule="evenodd"
        />
    </svg>
)

export const ErrorIcon = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" className={className}>
        <defs>
            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="uploaderroricongradient">
                <stop stopColor={giphyRed} offset="0%" />
                <stop stopColor={giphyPink} offset="100%" />
            </linearGradient>
        </defs>
        <path
            d="M12 4a8 8 0 110 16 8 8 0 010-16zm0 10.864c-.37 0-.685.13-.945.39-.26.261-.39.576-.39.946s.13.685.39.945c.26.26.575.39.945.39s.685-.13.945-.39c.26-.26.39-.575.39-.945s-.13-.685-.39-.945c-.26-.26-.575-.39-.945-.39zm1-7.328h-2V13.2h2V7.536z"
            transform="translate(-3.333 -4)"
            fill="url(#uploaderroricongradient)"
            fillRule="evenodd"
        />
    </svg>
)
